module.exports = __webpack_public_path__ + "static/Livery-25fd9eb11e3d7eaee84853b1d7b1c370.svg";